import { FormControlLabel as MuiFormControlLabel, radioClasses } from '@mui/material';
import { styled } from "../../../styles";
export var StyledFormControlLabel = styled(MuiFormControlLabel)(function (_ref) {
  var theme = _ref.theme;
  return "\n  .".concat(radioClasses.root, ":not(.").concat(radioClasses.checked, ") {\n    color: ").concat(theme.palette.grey[200], ";\n  }\n\n  .").concat(radioClasses.root, " {\n    &:hover {\n      background: none;\n    }\n  }\n");
});
//# sourceMappingURL=FormControlLabel.styled.js.map